import React from 'react';

export const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  isLoading = false,
  isFullWidth = false,
  leftIcon,
  rightIcon,
  className = '',
  disabled,
  ...props
}) => {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-medium transition-all focus:outline-none focus:ring-2 focus:ring-offset-1';
  
  const variants = {
    primary: 'bg-primary-500 text-white hover:bg-primary-600 active:bg-primary-700 focus:ring-primary-300 shadow-sm',
    secondary: 'bg-secondary-500 text-white hover:bg-secondary-600 active:bg-secondary-700 focus:ring-secondary-300 shadow-sm',
    accent: 'bg-accent-500 text-white hover:bg-accent-600 active:bg-accent-700 focus:ring-accent-300 shadow-sm',
    outline: 'border border-primary-300 text-primary-700 hover:bg-primary-50 active:bg-primary-100 focus:ring-primary-300',
    ghost: 'text-neutral-700 hover:bg-neutral-100 active:bg-neutral-200 focus:ring-neutral-300',
    link: 'text-primary-600 hover:text-primary-700 active:text-primary-800 underline-offset-2 hover:underline focus:ring-primary-300',
    ghibli: 'relative bg-white text-primary-700 border border-primary-200 hover:bg-primary-50 hover:border-primary-300 shadow-sm',
    natural: 'relative bg-primary-50 text-primary-700 border border-primary-200 hover:bg-primary-100 shadow-sm',
  };

  const sizes = {
    xs: 'px-2.5 py-1 text-xs',
    sm: 'px-3.5 py-1.5 text-sm',
    md: 'px-5 py-2 text-base',
    lg: 'px-6 py-2.5 text-lg',
    xl: 'px-7 py-3 text-xl',
  };

  const widthClass = isFullWidth ? 'w-full' : '';

  return (
    <button
      className={`
        ${baseStyles}
        ${variants[variant]}
        ${sizes[size]}
        ${widthClass}
        ${isLoading ? 'opacity-75 cursor-not-allowed' : ''}
        ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
        ${className}
      `}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading ? (
        <>
          <svg
            className="animate-spin -ml-1 mr-2 h-4 w-4 text-current"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
          <span>Loading...</span>
        </>
      ) : (
        <>
          {leftIcon && <span className="mr-2">{leftIcon}</span>}
          {children}
          {rightIcon && <span className="ml-2">{rightIcon}</span>}
          
          {/* 为ghibli按钮添加柔和装饰效果 */}
          {variant === 'ghibli' && (
            <span className="absolute inset-0 rounded-full overflow-hidden">
              <span className="absolute inset-0 rounded-full bg-gradient-to-r from-primary-100/20 to-accent-100/20 opacity-50"></span>
            </span>
          )}
          
          {/* 为natural按钮添加叶子装饰 */}
          {variant === 'natural' && (
            <span className="absolute -top-1.5 -right-1 w-6 h-6 opacity-20 pointer-events-none">
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M12,2 C9,6 3,8 3,13 C3,18 7,22 12,22 C17,22 21,18 21,13 C21,8 15,6 12,2 Z" fill="#5aaf8c" />
              </svg>
            </span>
          )}
        </>
      )}
    </button>
  );
};
